import { TRADE_QUARTER } from "../config/tradeQuarter";

/** Frame-rate independent, continuous at the end of every levitation cycle. */
export function tradeCrystalLift(elapsedMs: number, height: number, reducedMotion: boolean): number {
  if (reducedMotion) return 0;
  return Math.sin(elapsedMs * Math.PI * 2 / TRADE_QUARTER.motion.floatPeriodMs) * height * TRADE_QUARTER.motion.floatAmplitude;
}

/** Do not jump to a new phase when the browser returns from a suspended tab. */
export function advanceTradeMotion(elapsedMs: number, deltaMs: number): number {
  return elapsedMs + Math.max(0, Math.min(deltaMs, 50));
}
